module.exports = require('./lib/vue/player/frontend-video-player.umd.min.js');
